"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavMenuItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var _LinkWithWrapper = require("../LinkWithWrapper");

var _excluded = ["icon", "children", "description"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var NavMenuItemTitle = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1ur5ont2"
} : {
  target: "e1ur5ont2",
  label: "NavMenuItemTitle"
})(_styles.text.regularBold, " color:", _styles.color.darkest, ";");
var NavMenuItemDescription = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1ur5ont1"
} : {
  target: "e1ur5ont1",
  label: "NavMenuItemDescription"
})(_styles.text.regular, " color:", _styles.color.darkest, ";");
var PureMenuItem = ( /*#__PURE__*/0, _theming.styled)(_LinkWithWrapper.LinkWithWrapper, process.env.NODE_ENV === "production" ? {
  target: "e1ur5ont0"
} : {
  target: "e1ur5ont0",
  label: "PureMenuItem"
})(_styles.text.small, ";color:", _styles.color.darkest, ";text-decoration:none;display:flex;align-items:flex-start;padding:12px;&:hover,&:focus,&:active{", NavMenuItemTitle, "{color:", _styles.color.secondary, ";}}&:focus-visible{outline:2px solid ", _styles.color.secondary, ";border-radius:5px;", NavMenuItemTitle, "{color:", _styles.color.secondary, ";}}svg{flex:none;width:20px;height:20px;margin-right:15px;margin-top:4px;}");
var NavMenuItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var icon = _ref.icon,
      children = _ref.children,
      description = _ref.description,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(PureMenuItem, (0, _extends2["default"])({}, props, {
    ref: ref,
    role: "menuitem"
  }), icon, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(NavMenuItemTitle, null, children), /*#__PURE__*/_react["default"].createElement(NavMenuItemDescription, null, description)));
});
exports.NavMenuItem = NavMenuItem;
NavMenuItem.displayName = 'NavMenuItem';